import * as React from "react";
const SvgIconShiplyreact = props => <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}><g clipPath="url(#icon-shiply_react_svg__a)"><path fill="#0A6CFF" d="M9.999 18.642a8.301 8.301 0 1 0 0-16.603 8.301 8.301 0 0 0 0 16.603" style={{
      fill: "#0a6cff",
      fill: "color(display-p3 .04 .424 1)",
      fillOpacity: 1
    }} /><path fill="#fff" d="M6.382 16.325h8.126c.18 0 .207-.26.03-.296l-10.03-2.006a.15.15 0 0 0-.138.25l1.903 2.005a.15.15 0 0 0 .109.047" style={{
      fill: "#fff",
      fillOpacity: 1
    }} /><path fill="#fff" fillOpacity={0.7} d="M8.46 14.074c-1.078-3.712.848-7.484 1.945-8.906-4.116 3.293-4.49 6.786-4.565 8.308 1.078-.24 2.195.299 2.62.598" style={{
      fill: "#fff",
      fillOpacity: 0.7
    }} /><path fill="#0A6CFF" d="M13.773 14.75c-3.293-5.688-.366-12.253.507-13.5-5.941 4.843-5.771 11.255-5.222 13.5 1.018-.778 3.567-.325 4.715 0" style={{
      fill: "#0a6cff",
      fill: "color(display-p3 .04 .424 1)",
      fillOpacity: 1
    }} /><path fill="#fff" fillRule="evenodd" d="M13.585 2.56c-1.093 2.492-2.458 7.622.186 12.188-1.148-.324-3.697-.778-4.715 0-.509-2.08-.692-7.736 4.008-12.408q.265.1.52.22" clipRule="evenodd" style={{
      fill: "#fff",
      fillOpacity: 1
    }} /></g><defs><clipPath id="icon-shiply_react_svg__a"><path fill="#fff" d="M0 0h17.5v17.5H0z" style={{
        fill: "#fff",
        fillOpacity: 1
      }} transform="translate(1.25 1.25)" /></clipPath></defs></svg>;
export default SvgIconShiplyreact;